import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { finalize, map, Observable, shareReplay } from 'rxjs';

interface DocumentListResponse {
	payload?: unknown;
	[key: string]: unknown;
}

@Injectable({
	providedIn: 'root'
})
export class ContractDocumentListCoordinatorService {
	private readonly httpClient = inject(HttpClient);
	private readonly inFlight = new Map<string, Observable<DocumentListResponse>>();

	loadType(url: string, payload: Record<string, unknown>, type: string, context: HttpContext): Observable<DocumentListResponse> {
		const aggregatePayload = { ...payload };
		delete aggregatePayload['type'];

		const key = JSON.stringify([
			url,
			aggregatePayload['code'] ?? null,
			aggregatePayload['pin'] ?? null,
			aggregatePayload['context'] ?? null
		]);

		let request = this.inFlight.get(key);
		if (!request) {
			const sharedRequest = this.httpClient.post<DocumentListResponse>(url, aggregatePayload, { context }).pipe(
				finalize(() => this.inFlight.delete(key)),
				shareReplay({ bufferSize: 1, refCount: false })
			);
			request = sharedRequest;
			this.inFlight.set(key, request);
		}

		return request.pipe(
			map((response) => ({
				...response,
				payload: this.itemsForType(response?.payload, type)
			}))
		);
	}

	private itemsForType(payload: unknown, type: string): unknown[] {
		if (!payload || Array.isArray(payload) || typeof payload !== 'object') {
			return [];
		}

		const items = (payload as Record<string, unknown>)[type];
		return Array.isArray(items) ? items : [];
	}
}
